import React from "react";
import { MdClose } from "react-icons/md";

import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import Uac from "components/layout/uac";
import theme from "styles/theme";

import { Container } from "./styles";
import { ContainerButtons, ModalHeader, ModalStyle, Title } from "../styles";

type BirthDateAUCProps = {
  openModal: boolean;
  modalFunction: (value: boolean) => void;
};

const BirthDateAUC = ({
  openModal,
  modalFunction,
}: BirthDateAUCProps): JSX.Element => {
  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Atenção</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Title>Entre em contato com nosso atendimento</Title>
        <p>
          Cadastro não permitido para menores de 18 anos, entre em contato com a
          Unidade de Atendimento Cliente em caso de emancipação
        </p>
        <Uac />
        <ContainerButtons>
          <OutlinedButton
            color={theme.colors.purple}
            onClick={() => modalFunction(false)}
          >
            Cancelar
          </OutlinedButton>
          <ContainedButton onClick={() => modalFunction(false)}>
            Ok
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default BirthDateAUC;
